import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "@components/layout"
import SEO from "@components/seo"
import { Container, Row, Col } from "react-bootstrap"

import { LazyLoadComponent } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"
import PostModal from "@components/blogPostModal/modal"

import { StaticImage } from "gatsby-plugin-image"

import HeroSwiper from "@components/swiper/inside-fluo-swiper"
import Flow from "@components/sections/flow-inside-fluo"
import Timeline from "@components/sections/timeline"

// images

const InsideFluoPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="The Art of Living | FLUO" />
      <div className="index inside-fluo">
        <HeroSwiper />
        <div id="echo" />
        <section className="resonant-story">
          <div className="scrolldown text-center">
            <Link to="/inside-fluo/#echo">
              <StaticImage
                className="img-fluid mb-5"
                src="../../images/scroll-down.png"
                alt="Logo"
              />
            </Link>
          </div>
          <Container>
            <Row className="justify-content-end">
              <Col lg="8 mx-auto" className="">
                <div className="belief-content text-left text-white">
                  <h6 className="font-weight-bold mb-4 font-inter text-uppercase"></h6>
                  <h2 className="section-title mb-3">The Echo of FLUO</h2>

                  <p>
                    Over the years, what I’ve learned to be true is that this
                    very ancient wisdom now combined with modern science in
                    physics and psychology, as well as measured against the
                    experiences and texts of other academics and enlightened
                    avatars alive today and those of the last few thousand
                    years, really make clear how the act of flowing this energy
                    is essential to a fulfilling life. We spend so much of our
                    lives in resistance to everything and everyone and
                    ultimately end up attracting the very things we wish to
                    avoid. Then we blame it all on life, or others. Since
                    studying flow, the science and biology of this superhuman
                    experience (many call a “flow state”), and integrating what
                    I have learned my life has come so far from its beginnings
                    that I can hardly recognize my past self. My mindset and
                    perception has been forever altered in a way the serves me
                    greater than my wildest dreams.
                  </p>
                  {/* <div className="d-flex align-items-center justify-content-center">
                    <Link className="cta mt-4 mx-2 text-uppercase" to="/">
                      Full Story
                    </Link>
                  </div> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Flow />
        <Timeline />
        <section className="prefooter-section section-padding">
          <Container fluid>
            <div class="row d-flex justify-content-center">
              <div class="col-lg-2 col-md-6 mb-4">
                <div className="prefooter-list text-center text-white">
                  <div className="product-item">
                    <Link to="/stories/" className="">
                      <StaticImage
                        className="img-fluid mb-3"
                        width={120}
                        height={100}
                        src="../../images/our-story.png"
                        alt="Our Story"
                      />
                      <h3 className="font-weight-bold mb-3">Our Story</h3>
                    </Link>
                    <p className="mb-4">
                      We want to bend history in the right direction.
                    </p>
                    <Link to="/stories/" className="cta-2 text-uppercase ">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 mb-4">
                <div className="prefooter-list text-center text-white">
                  <div className="product-item">
                    <Link to="/rally/" className="">
                      <StaticImage
                        className="img-fluid mb-3"
                        width={100}
                        height={100}
                        src="../../images/our-rally.png"
                        alt="Our Rally"
                      />
                      <h3 className="font-weight-bold mb-3">Our Rally</h3>
                    </Link>
                    <p className="mb-4">
                      The FLUO
                      <br />
                      Revolution
                      <br /> has begun.
                    </p>
                    <Link to="/rally/" className="cta-2 text-uppercase ">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 mb-4">
                <div className="prefooter-list text-center text-white">
                  <div className="product-item">
                    <Link to="/belief/" className="">
                      <StaticImage
                        className="img-fluid mb-3"
                        width={100}
                        height={100}
                        src="../../images/our-beliefs.png"
                        alt="Our Beliefs"
                      />
                      <h3 className="font-weight-bold mb-3">Our Beliefs</h3>
                    </Link>
                    <p className="mb-4">
                      Discover the Art of Living. Know freedom. Feel Alive
                      <sup>®</sup>.
                    </p>
                    <Link to="/belief/" className="cta-2 text-uppercase ">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 mb-4">
                <div className="prefooter-list text-center text-white">
                  <div className="product-item">
                    <Link to="/why-fluo/" className="">
                      <StaticImage
                        className="img-fluid mb-3"
                        width={100}
                        height={100}
                        src="../../images/our-youth.png"
                        alt="Our Youth"
                      />
                      <h3 className="font-weight-bold mb-3">Our Youth</h3>
                    </Link>
                    <p className="mb-4">
                      Discover the FLUO Foundation, a youth mental health
                      nonprofit.
                    </p>
                    <Link to="/why-fluo/" className="cta-2 text-uppercase ">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 mb-4">
                <div className="prefooter-list text-center text-white">
                  <div className="product-item">
                    <Link to="/stewardship/" className="">
                      <StaticImage
                        className="img-fluid mb-3"
                        width={100}
                        height={100}
                        src="../../images/our-ways.png"
                        alt="Our Ways"
                      />
                      <h3 className="font-weight-bold mb-3">Our Ways</h3>
                    </Link>
                    <p className="mb-4">
                      Consciousness
                      <br />&<br /> Stewardship
                    </p>
                    <Link to="/stewardship/" className="cta-2 text-uppercase ">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </Layout>
  )
}

export default InsideFluoPage
